var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radios"},[_vm._t("default",function(){return _vm._l((_vm.radios),function(item,index){return _c('Radio',{key:index,staticClass:"radio-item",attrs:{"radio":item},on:{"switchStatus":_vm.switchStatus}})})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }